import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import arrow from './icons_android/arrow_left_android.svg';
import x_close_android from './icons_android/x_close_android.svg';
import { finish } from '../pages_android/custom_views/insta_custom_views/utils_android/AndroidMethods';
import { getIsAndroid, getIsDesktop, getMoneyType, getSmoozieMultiplier, isShowBackBtn, Pages } from '../pages_android/custom_views/insta_custom_views/utils_android/UtilsAndroid';
import more from '../icons/menu/more.svg'
import profile from '../icons/menu/profile.svg'
import chats from '../icons/menu/chats.svg'
import useAnimatedNumber from '../motion/useAnimatedNumber';
import { getHeaderCountDelay } from '../motion/celebrate';
function NavbarAndroid({ isUpmob, count_money_r, toogleMenu, onBack, isClose, getMyInfo, balanceLoading, chatUnread }) {
    const navigate = useNavigate();
    // Баланс «докручивается» до нового значения; после выполнения задания —
    // в момент, когда в шапку долетают монеты из праздничного экрана.
    // Пока сведения о пользователе грузятся (первый запуск), вместо «0» мерцает заглушка;
    // настоящий баланс потом появляется сразу, без «прокрутки» от нуля.
    const balance = useAnimatedNumber(balanceLoading ? undefined : count_money_r, { duration: 900, delay: getHeaderCountDelay, bumpMs: 700 });
    // в первой отрисовке после загрузки хук ещё не принял значение (это делает его эффект) —
    // показываем сам баланс, а не NaN
    const shownBalance = (typeof balance.value === 'number' && isFinite(balance.value)) ? balance.value : (parseFloat(count_money_r) || 0);
    const moneyClass = "header_money hover" +
        (balance.phase === 'counting' ? ' is-counting' : '') +
        (balance.phase === 'done' ? ' is-bump' : '');

    const sideButtonClicked = () => {
        if (window.location.pathname !== '/') {
            // переписка открыта прямо по ссылке (раньше в приложении ничего не открывали) —
            // «назад» ведёт к списку чатов, а не из приложения
            const historyIndex = window.history.state && window.history.state.idx;
            if (window.location.pathname.includes(Pages.chats) && !historyIndex) {
                navigate('/' + Pages.chats, { replace: true });
                return;
            }
            navigate(-1);
            getMyInfo()
        } else {
            toogleMenu();
        }
    };

    const closeUpmob = () => {
        finish();
    };
    const isDesktop = getIsDesktop()
    // const showBackButton = window.location.pathname !== '/';

    return (
        <header 
            style={isUpmob ? {} : {background: ""}} 
            className="header justify_content not_selectable"
        >
            <div style={{width : '100%', height : '56px'}} className="flex just_cont">
                {/* <img 
                    onClick={sideButtonClicked} 
                    src={showBackButton ? arrow : burger} 
                    className={showBackButton ? 'header__mobile-menu_back' : 'header__mobile-menu_burger'}
                    alt=""
                /> */}
                <div className='flex'>
                    {!isShowBackBtn() && <img 
                        onClick={sideButtonClicked} 
                        src={arrow} 
                        className={'header__mobile-menu_back hover'}
                        alt="back"
                    />}
                
                    {(!isDesktop && getIsAndroid()) ? <Link to={Pages.tasks}><p className="header_title hover">{isUpmob ? "Бонус" : "Smoozi"}</p></Link>
                    :
                    <Link to={Pages.tasks} style={{marginLeft : '0'}} className="navbar_item_center hover"><div style={{marginLeft : '0'}} className='navbar_item_text'>{window.location.href.includes(Pages.need_rework) ? "Доработки"  : "Все задания"}</div></Link>}
                </div>
                <div className='flex'>
                    {isDesktop && <Link to={'/' + Pages.chats} className="navbar_item_center hover" aria-label={chatUnread > 0 ? 'Чаты: непрочитанных ' + chatUnread : 'Чаты'}>
                        <div className='flex'>
                            <img alt='' className='' src={chats}/>
                            <div className='navbar_item_text'>Чаты</div>
                            {chatUnread > 0 && <span className='navbar_chats_badge'>{chatUnread > 99 ? '99+' : chatUnread}</span>}
                        </div>
                    </Link>}

                    {isDesktop && <Link to={Pages.profile} className="navbar_item_center hover">
                        <div className='flex'>
                            <img alt='' className='' src={profile}/>
                            <div className='navbar_item_text'>Профиль</div>
                        </div>
                    </Link>}
                   
                    {balanceLoading ?
                        <span style={isUpmob ? {} : {display : 'none'}} className="header_money header_money--loading" aria-hidden="true" />
                    :
                    <Link to={Pages.payouts} style={isUpmob ? {} : {display : 'none'}} className={moneyClass}>
                        {Math.floor(shownBalance * getSmoozieMultiplier())}{getMoneyType(isUpmob)}
                    </Link>}
                </div>
            </div>
            {!isUpmob && <img 
                onClick={closeUpmob} 
                className={(!isUpmob || isClose) ? "close_nav" : "not_display"} 
                src={x_close_android} 
                alt=""
            />}
        </header>
    );
}

export default NavbarAndroid;